import React, { PureComponent } from "react";
import {
  Radar,
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
  Legend,
} from "recharts";

const data = [
  {
    name: "HTML",
    A: 95,
    B: 50,
    C: 99,
    fullMark: 100,
  },
  {
    name: "CSS",
    A: 95,
    B: 50,
    C: 99,
    fullMark: 100,
  },
  {
    name: "JS",
    A: 80,
    B: 40,
    C: 99,
    fullMark: 100,
  },
  {
    name: "ReactJS",
    A: 60,
    B: 15,
    C: 99,
    fullMark: 100,
  },
  {
    name: "Illustrator",
    A: 85,
    B: 45,
    C: 99,
    fullMark: 100,
  },
  {
    name: "Photoshop",
    A: 75,
    B: 30,
    C: 99,
    fullMark: 100,
  },
  {
    name: "Git",
    A: 75,
    B: 10,
    C: 99,
    fullMark: 100,
  },
  {
    name: "NodeJS",
    A: 50,
    B: 10,
    C: 99,
    fullMark: 100,
  },
];

export default class SkillChart extends PureComponent {
  render() {
    return (
      <RadarChart outerRadius={100} width={350} height={350} data={data}>
        <PolarGrid />
        <PolarAngleAxis dataKey="name" />
        <PolarRadiusAxis />
        <Radar
          name="Years Ago"
          dataKey="B"
          stroke="#c45151"
          fill="#c45151"
          fillOpacity={0.9}
        />
        <Radar
          name="Me Now"
          dataKey="A"
          stroke="#fece2f"
          fill="#fece2f"
          fillOpacity={0.8}
        />
        <Radar
          name="Hopefully Future Me"
          dataKey="C"
          stroke="#516ec4"
          fill="#516ec4"
          fillOpacity={0.2}
        />
        <Legend />
      </RadarChart>
    );
  }
}
